import { createApp } from 'vue';
import App from './App.vue';
import './assets/tailwind.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Add this line

createApp(App).mount('#app');